import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  ViewChild,
  ElementRef,
  Input,
  AfterViewInit,
  ViewEncapsulation
} from "@angular/core";
import * as nouislider from "nouislider";
import { SliderConfig } from "./range-slider.interface";
import { CurrencyPipe } from "@angular/common";
import { AppContext } from "src/app/services/app-context.service";

@Component({
  selector: "travel-ui-range-slider",
  templateUrl: "./range-slider.component.html",
  styleUrls: ["./no-ui-slider.css", "./range-slider.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class RangeSliderComponent implements OnInit {
  @Input() set setConfig(data: SliderConfig) {
    this.config = data;
    this.initialize();
  };
  config: any;
  defaultConfig: SliderConfig = {
    label: "",
    options: [],
    connect: true,
    range: {
      min: 0,
      max: 100
    },
    format: {
      to: (value: any) => {
        return this.formatTooltip(value, this);
      },
      from: Number
    },
    start: [0]
  };

  selectedVals: any[] = [];
  distanceUnit!: string;

  @Output() changeVal: EventEmitter<Array<any>> = new EventEmitter();
  @ViewChild("slider", { static: true }) slider!: ElementRef;
  private sliderRef!: nouislider.API;
  constructor(private currencyPipe: CurrencyPipe, public appcontext: AppContext) { }

  ngOnInit() { }

  initialize() {
    if (this.config.range && !this.config.start) {
      if(this.config.label ==='PriceGroup'){
        this.config.start = [this.config.range.min, this.config.range.max];
        this.selectedVals = [this.config.range.min, this.config.range.max];
      }
      if(this.config.label ==='Distance'){
        if(this.appcontext.siteName != 'FTD'){
          this.distanceUnit = "Miles"
      this.config.start = [this.config.range.min, this.config.range.max];
      this.selectedVals = [this.config.range.min * 0.6, this.config.range.max * 0.6];
      this.config.range.min = this.config.range.min * 0.6;
      this.config.range.max = this.config.range.max * 0.6;
        }
        else{
          this.distanceUnit = "Km"
          this.config.start = [this.config.range.min, this.config.range.max];
         this.selectedVals = [this.config.range.min, this.config.range.max];
         this.config.range.min = this.config.range.min;
        this.config.range.max = this.config.range.max;
        }
    }
  }
    this.config = Object.assign(this.defaultConfig, this.config, {
      tooltips: true
    });

    this.initSlider();
  }
  // ngAfterContentInit() {}
  updateSliderRef() {
    const _self = this;
    this.sliderRef.on("set", ($event: any[], handle: any) => {
      this.updateSliderVal($event, _self);
    });
  }

  // updateRange(range: { min: any; max: any }) {
  //   this.defaultConfig = Object.assign(this.defaultConfig, {
  //     range: range,
  //     start: [range.min, range.max]
  //   });
  //   this.config = Object.assign(this.defaultConfig, this.config, {
  //     tooltips: false,
  //     pips: {
  //       mode: 'range',
  //       density: 3
  //     }
  //   });
  //   this.sliderRef.destroy();
  //   this.initSlider();
  // }

  initSlider() {
    this.config = Object.assign(this.config, {
      range: this.config.range,
      start: this.config.start,
      tooltips: false
      // pips removed - no scale markers will be shown
    });
    this.sliderRef = nouislider.create(this.slider.nativeElement, this.config);
    this.updateSliderRef();
    // this.sliderRef.set(this.config.initialValues);
  }

  formatTooltip(value: string, _self: this) {
    _self.config.unit = _self.config.unit ? _self.config.unit : "";
    return this.currencyPipe.transform(
      parseInt(value, 10).toString(),
      _self.config.unit
    );
  }

  updateSliderVal($event: Array<string>, _self: this) {
    let formattedEvent: Array<any> = [];
    formattedEvent = $event.map(r => {
      return parseInt(r.replace(/[^\d\.]/g, ""), 10);
    });
    _self.changeVal.emit(formattedEvent);
    this.selectedVals = formattedEvent
  }
  updateMin(event: any) {
    // Only update the selectedVals array, don't update slider during typing
    let originalValue = event.target.value;
    originalValue = originalValue.replace(/,/g, ""); // remove commas
    const value = Number(originalValue);
    if (!isNaN(value)) {
      this.selectedVals[0] = value;
    }
  }

  updateMinOnChange(event: any) {
    let originalValue = event.target.value;
      originalValue = originalValue.replace(/,/g, ""); // remove commas
    const value = Number(originalValue);
    if (!isNaN(value) && value >= this.config.range.min && value <= this.config.range.max && value <= this.selectedVals[1]) {
      this.selectedVals[0] = value;
      this.sliderRef.set([value, this.selectedVals[1]]);
      this.changeVal.emit(this.selectedVals);
      document.getElementsByClassName('custom-price-range-input')[0].classList.remove('error');
      const inputElement = document.querySelector('#range-min-input')?.closest('.custom-price-range-input');
      inputElement?.addEventListener('blur', function (event) {
        // document.getElementsByClassName('custom-price-range-input')[1].classList.remove('error')
        document.getElementsByClassName('custom-price-range-input')[0].classList.remove('error');
      });
    } else {
      // Reset to current value if invalid
      event.target.value = this.selectedVals[0];
       document.getElementsByClassName('custom-price-range-input')[0].classList.add('error');
       const inputElement = document.querySelector('#range-min-input')?.closest('.custom-price-range-input');
          inputElement?.addEventListener('blur', function (event) {
          // document.getElementsByClassName('custom-price-range-input')[1].classList.remove('error')
          document.getElementsByClassName('custom-price-range-input')[0].classList.add('error')
          });
    }
  }

  updateMax(event: any) {
    // Only update the selectedVals array, don't update slider during typing
    let originalValue = event.target.value;
    originalValue = originalValue.replace(/,/g, ""); // remove commas
    const value = Number(originalValue);
    if (!isNaN(value)) {
      this.selectedVals[1] = value;
    }
  }

  updateMaxOnChange(event: any) {
    let originalValue = event.target.value;
    originalValue = originalValue.replace(/,/g, ""); // remove commas
    const value = parseInt(originalValue,10);
    if (!isNaN(value) && value >= this.config.range.min && value <= this.config.range.max && value >= this.selectedVals[0]) {
      this.selectedVals[1] = value;
      this.sliderRef.set([this.selectedVals[0], value]);
      this.changeVal.emit(this.selectedVals);
      document.getElementsByClassName('custom-price-range-input')[1].classList.remove('error');
      const inputElement = document.querySelector('#range-max-input')?.closest('.custom-price-range-input');
          inputElement?.addEventListener('blur', function (event) {
        document.getElementsByClassName('custom-price-range-input')[1].classList.remove('error');
        // document.getElementsByClassName('custom-price-range-input')[0].classList.remove('error')
      });

    } else {
      // Reset to current value if invalid
      event.target.value = this.selectedVals[1];
      document.getElementsByClassName('custom-price-range-input')[1].classList.add('error');
      const inputElement = document.querySelector('#range-max-input')?.closest('.custom-price-range-input');
      inputElement?.addEventListener('blur', function (event) {
        document.getElementsByClassName('custom-price-range-input')[1].classList.add('error');
        // document.getElementsByClassName('custom-price-range-input')[0].classList.remove('error')
      });

    }
  }

  onInputFocus(event: any) {
    // Select all text when input is focused for easier editing
    event.target.select();
  }

  onInputBlur(event: any) {
    // Store the original value before any processing
    let originalValue = event.target.value;
    originalValue = originalValue.replace(/,/g, ""); // remove commas
    const value = parseInt(originalValue,10);
    // Only update if the value is valid and different from current
    if (!isNaN(value) && value !== this.selectedVals[0] && value !== this.selectedVals[1]) {
      // Determine if this is min or max input based on the input element
      const isMaxInput = event.target === document.getElementsByClassName('custom-price-range-input')[1];

      if (isMaxInput) {
        // This is the max input
        if (value >= this.config.range.min && value <= this.config.range.max && value >= this.selectedVals[0]) {
          this.selectedVals[1] = value;
          this.sliderRef.set([this.selectedVals[0], value]);
          this.changeVal.emit(this.selectedVals);
          event.target.classList.remove('error');
          const inputElement = document.querySelector('#range-max-input')?.closest('.custom-price-range-input');
          inputElement?.addEventListener('blur', function (event) {
          document.getElementsByClassName('custom-price-range-input')[1].classList.remove('error')
          // document.getElementsByClassName('custom-price-range-input')[0].classList.remove('error')
          });

        } else {
          // Invalid value, restore original
          event.target.value = this.selectedVals[1];
          event.target.classList.add('error');
          const inputElement = document.querySelector('#range-max-input')?.closest('.custom-price-range-input');
          inputElement?.addEventListener('blur', function (event) {
          document.getElementsByClassName('custom-price-range-input')[1].classList.add('error')
          // document.getElementsByClassName('custom-price-range-input')[0].classList.remove('error')
          });
        }
      } else {
        // This is the min input
        if (value >= this.config.range.min && value <= this.config.range.max && value <= this.selectedVals[1]) {
          this.selectedVals[0] = value;
          this.sliderRef.set([value, this.selectedVals[1]]);
          this.changeVal.emit(this.selectedVals);
          event.target.classList.remove('error');
          const inputElement = document.querySelector('#range-min-input')?.closest('.custom-price-range-input');
          inputElement?.addEventListener('blur', function (event) {
          // document.getElementsByClassName('custom-price-range-input')[1].classList.remove('error')
          document.getElementsByClassName('custom-price-range-input')[0].classList.remove('error')
          });
        } else {
          // Invalid value, restore original
          event.target.value = this.selectedVals[0];
          event.target.classList.add('error');
          const inputElement = document.querySelector('#range-min-input')?.closest('.custom-price-range-input');
          inputElement?.addEventListener('blur', function (event) {
          // document.getElementsByClassName('custom-price-range-input')[1].classList.remove('error')
          document.getElementsByClassName('custom-price-range-input')[0].classList.remove('error')
          });
        }
      }
    } else if (!isNaN(value)) {
      // Value is valid but same as current, just ensure proper formatting
      event.target.value = value.toString();
    } else {
      // Invalid input, restore the appropriate current value
      const isMaxInput = event.target === document.getElementsByClassName('custom-price-range-input')[1];
      event.target.value = isMaxInput ? this.selectedVals[1] : this.selectedVals[0];
    }
  }
}
